import React from 'react'
import {useCanManageFirmwareBuilds, useCanRunFirmwareRollout} from '../hooks/firmwarePermissions'

/**
 * ITOP-928 / ITOP-925. A firmware route that exists for every role and says so when the role
 * may not use it.
 *
 * These routes used to be registered only for Admin, so any other role fell through to the
 * catch-all and saw "Page Not Found". That told a Company user the page did not exist when it
 * did, and was the whole of ITOP-925's symptom. A refused role now gets a sentence that is true.
 *
 * Cosmetic, like the permissions it reads: the backend refuses these calls on its own.
 */
type Props = {
  permission: 'rollout' | 'builds'
  children: React.ReactNode
}

export const FirmwareNotAuthorised: React.FC = () => (
  <div className='card'>
    <div className='card-body'>
      <h3 className='mb-3'>Not authorised</h3>
      <p className='text-muted mb-0'>
        Your login does not have access to this firmware page. Ask an administrator if you need it.
      </p>
    </div>
  </div>
)

const FirmwareAccessGuard: React.FC<Props> = ({permission, children}) => {
  const canRunRollout = useCanRunFirmwareRollout()
  const canManageBuilds = useCanManageFirmwareBuilds()
  const allowed = permission === 'builds' ? canManageBuilds : canRunRollout

  return allowed ? <>{children}</> : <FirmwareNotAuthorised />
}

export default FirmwareAccessGuard
